import { render } from "./DataDetailView.vue?vue&type=template&id=daf93252&scoped=true"
import script from "./DataDetailView.vue?vue&type=script&lang=js"
export * from "./DataDetailView.vue?vue&type=script&lang=js"

import "./DataDetailView.vue?vue&type=style&index=0&id=daf93252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf93252"]])

export default __exports__